/**
 * Slugs and page titles of the /for-creators/<slug> landing pages: all the
 * router and the page-title map need at startup. The page copy lives in
 * creatorAudienceContent.ts, loaded with the ForCreators page.
 */
export const creatorAudiencePath = (slug: string) => `/for-creators/${slug}`;

export const CREATOR_AUDIENCE_ROUTES = [
  { slug: 'life-mindset-coaches', seoTitle: 'Guided Journaling for Life & Mindset Coaches | Journal Party' },
  { slug: 'career-business-coaches', seoTitle: 'Guided Journaling for Career & Business Coaches | Journal Party' },
  { slug: 'wellness-mindfulness-creators', seoTitle: 'Guided Journaling for Wellness & Mindfulness Creators | Journal Party' },
  { slug: 'course-membership-creators', seoTitle: 'Guided Journaling for Course & Membership Creators | Journal Party' },
  { slug: 'writers-podcasters', seoTitle: 'Guided Journaling for Writers & Podcasters | Journal Party' },
  { slug: 'journaling-workbook-creators', seoTitle: 'Guided Journaling for Journal & Workbook Creators | Journal Party' },
] as const;

export type CreatorAudienceSlug = (typeof CREATOR_AUDIENCE_ROUTES)[number]['slug'];
